import React, { Component } from 'react';
import {Icon} from "@blueprintjs/core";

class QuoteLinesTable extends Component {

    render() {
        return (this.props.quoteLines.size > 0
                ? (
                    <table className="table">
                        <thead>
                        <tr className="d-flex">
                            <th className="col-2 " style={{borderBottom: 'none'}}>Producto</th>
                            <th className="col-3" style={{borderBottom: 'none'}}>Comentarios</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right'}}>Cantidad</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right', minWidth: 100}}>Precio coste</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right'}}>PVP</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right', minWidth: 120}}>Descuento (%)</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right'}}>IVA (%)</th>
                            <th className="col " style={{borderBottom: 'none', textAlign: 'right'}}>Total</th>
                            <th className="col-1 " style={{borderBottom: 'none'}}></th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.props.quoteLines.map((line, i) => {
                            return (
                                <tr
                                    className="d-flex"
                                    key={'line-' + i}
                                    style={{
                                        transition: 'all 0.4s',
                                        ...this.props.editLineIndex === i ? {
                                            backgroundColor: 'rgb(26, 179, 148, 0.1)',
                                        } : {}
                                    }}
                                >
                                    <td className="col-2">{line.getIn(['product', 'name'])}</td>
                                    <td className="col-3">{line.get('comments')}</td>
                                    <td className="col" style={{ textAlign: 'right' }} >{line.get('amount')}</td>
                                    <td className="col" style={{ textAlign: 'right', minWidth: 100 }} >{line.get('cost_price')}</td>
                                    <td className="col" style={{ textAlign: 'right' }} >{line.get('sale_price')}</td>
                                    <td className="col" style={{ textAlign: 'right', minWidth: 120 }} >{line.get('discount')}</td>
                                    <td className="col" style={{ textAlign: 'right' }} >{line.get('vat')}</td>
                                    <td className="col" style={{ textAlign: 'right' }} >{line.get('total')}</td>
                                    <td className="col-1 d-flex justify-content-center">
                                        { this.props.editMode && this.props.editLineIndex === -1
                                            ? [
                                                <Icon
                                                    key="getLineToEdit"
                                                    className="cursor-pointer"
                                                    icon="edit"
                                                    title="Editar"
                                                    style={{marginLeft: 0}}
                                                    onClick={() => this.props.getLineToEdit(i) }
                                                />,
                                                <Icon
                                                    key="deleteLine"
                                                    className="cursor-pointer"
                                                    icon="trash"
                                                    title="Eliminar"
                                                    style={{marginLeft: 10}}
                                                    onClick={() => this.props.deleteLine(i) }
                                                />
                                            ]: null
                                        }
                                    </td>
                                </tr>
                            )
                        })}
                        </tbody>
                    </table>
                ) : 'No hay lineas de presupuesto.'
        );
    }

}

export default QuoteLinesTable;


// WEBPACK FOOTER //
// ./src/components/common/QuoteLinesTable.js